<template>
  <div class="text-center" v-if="step == 1">
    <v-icon :icon="RedTriangle" size="40"/>
    <div class="title mt-2 mb-2">
      {{$t('Удалить страницу?')}}
    </div>
    <div class="d-flex justify-center text-center mb-4">
      <div class="delete-description">
        {{$t('После удаления страница станет недоступна всем пользователям. Восстановить её будет невозможно')}}
      </div>
    </div>
    <div>
      <v-btn variant="flat" color="primary" @click="deleteTap()" rounded="lg" class="w-100">
        {{$t('Да, удалить')}}
      </v-btn>
    </div>
  </div>
  <div class="text-center" v-else>
    <div class="title mt-2 mb-2">
      {{$t('Страница удалена')}}
    </div>
    <div class="d-flex justify-center text-center mb-4">
      <div class="delete-description">
        {{$t('Страница успешно удалена и больше недоступна по ссылке')}}
      </div>
    </div>
    <div>
      <v-btn variant="flat" color="primary" @click="goBack()" rounded="lg" class="w-100">
        {{$t('Понятно')}}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">

import {ref} from "vue";
import RedTriangle from "~/assets/icons/red-triangle.vue";
import {useDialogStore} from "@/stores/dialogStore";
import {useTapStore} from '@/stores/tapStore';
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  id: { type: Number }
})

const tapStore = useTapStore();

const dialogStore = useDialogStore()

const step = ref(1)

async function deleteTap() {
  try {
    await tapStore.deleteTap(props.id)

    step.value = 2

    if (route.path.includes('/edit') || route.path.includes('/view')) {
      await router.replace('/profile')
    } else {
      await tapStore.getTapList()
    }
  } catch (err: any) {}
}

function goBack() {
  dialogStore.close(!route.path.includes('/edit'))
}

</script>

<style scoped lang="sass">
.title
  color: #363636
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
.delete-description
  color: #363636
  text-align: center
  font-size: 14px
  font-weight: 400
  line-height: normal
  max-width: 280px
</style>
